import { AplicacionService } from '../../services/aplicacion.service';
import { Injectable } from "@angular/core";
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class AccesoEffects {

	constructor( private actions$: Actions, private store: Store<AppState>, private service: AplicacionService, private toastService: ToastService ) {
	}

}